const KStatConstants = {
  EVENT_FUNC_RESULT: 'func_result',
  EVENT_BUTTON_CLICK: 'button_click',
  EVENT_PAGE_SHOW: 'page_show',
  KEY_URL: 'url',
  KEY_COMP: 'comp',
  KEY_FUNC_NAME: 'func_name',
  KEY_BUTTON_NAME: 'button_name',
  KEY_PAGE_NAME: 'page_name',
  KEY_DATA1: 'data1',
  KEY_DATA2: 'data2',
  KEY_DATA3: 'data3',
  KEY_DATA4: 'data4',
  KEY_DATA5: 'data5',
};

function eventButtonClick(
  buttonName: string,
  funcName = '',
  urlStr = '',
  compStr = 'public',
  data1Str = '',
  data2Str = '',
  data3Str = '',
  data4Str = '',
  data5Str = '',
) {
  try {
    window.dw.onEvent(KStatConstants.EVENT_BUTTON_CLICK, {
      button_name: buttonName,
      url: urlStr,
      func_name: funcName,
      comp: compStr,
      data1: data1Str,
      data2: data2Str,
      data3: data3Str,
      data4: data4Str,
      data5: data5Str,
    });
  } catch (error) {
    console.error('eventButtonClick error:', error);
  }
}

function eventPageShow(
  pageName: string,
  funcName = '',
  urlStr = '',
  compStr = 'public',
  data1Str = '',
  data2Str = '',
  data3Str = '',
  data4Str = '',
  data5Str = '',
) {
  try {
    window.dw.onEvent(KStatConstants.EVENT_PAGE_SHOW, {
      page_name: pageName,
      url: urlStr,
      func_name: funcName,
      comp: compStr,
      data1: data1Str,
      data2: data2Str,
      data3: data3Str,
      data4: data4Str,
      data5: data5Str,
    });
  } catch (error) {
    console.error('eventPageShow error:', error);
  }
}

function eventFuncResult(
  resultName: string,
  funcName = '',
  urlStr = '',
  compStr = 'public',
  data1Str = '',
  data2Str = '',
  data3Str = '',
  data4Str = '',
  data5Str = '',
) {
  try {
    window.dw.onEvent(KStatConstants.EVENT_FUNC_RESULT, {
      result_name: resultName,
      func_name: funcName,
      url: urlStr,
      comp: compStr,
      data1: data1Str,
      data2: data2Str,
      data3: data3Str,
      data4: data4Str,
      data5: data5Str,
    });
  } catch (error) {
    console.error('eventFuncResult error:', error);
  }
}

export default {
  eventButtonClick,
  eventPageShow,
  eventFuncResult,
  KStatConstants,
};
